<h1 mat-dialog-title *ngIf="Edit==true">Edit Slide</h1>
<h1 mat-dialog-title *ngIf="Edit!=true">Add Slide</h1>

<div mat-dialog-content style="display: flex;flex-direction: column;overflow: hidden;">

  <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;" class="get-label">Name</mat-label>
    <input style="width: 500px;" type="text" matInput placeholder="Name" [(ngModel)]="Name" class="get-Input">
  </div>

  <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;">Select Slide Type</mat-label>
    <mat-radio-group [(ngModel)]="SelectedSlideType">
      <mat-radio-button [value]="1">Image</mat-radio-button>
      <mat-radio-button [value]="2">URL</mat-radio-button>
    </mat-radio-group>
  </div>

  <div *ngIf="SelectedSlideType==1">

    <div *ngIf="Edit==true" class="example-full-width" style="width: 500px;display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;margin-top: 12px;">
      <mat-label style="font-weight: bold;">Uploaded File</mat-label>
      <div *ngIf="Edit == true && slide.Slide">
        <img [src]="getImage(slide.Slide)" alt="No File Uploaded" style="width:200px;margin-left: 10px;">

      </div>
    </div>

    <div *ngIf="Edit==true" class="example-full-width" style="width: 500px;display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;margin-top: 12px;">
      <mat-label style="font-weight: bold;">Pick a different file</mat-label>
      <div *ngIf="Edit == true">
        <label>

          <input #imageInput type="file" accept="image/*" (change)="onFileChanged($event);">
        </label>

        <img *ngIf="ImagePreview && ImagePreview.length >0" [src]="ImagePreview" alt="No File Uploaded"
          style="width:200px;margin-left: 10px;">


      </div>


    </div>

    <div *ngIf="Edit!=true">
      <label>
        
        <input #imageInput type="file" accept="image/*" (change)="onFileChanged($event);">
      </label>
      <!-- <button mat-raised-button (change)="onFileChanged($event)">Choose File</button> -->
      <img *ngIf="ImagePreview && ImagePreview.length >0" [src]="ImagePreview" alt="No File Uploaded" style="width:200px;margin-left: 10px;">

    </div>

  </div>

  <div *ngIf="SelectedSlideType==2">
    <div>
      <img src="/Content/Images/VideoURL.png" style="width:50%;margin-left: 26%;">
    </div>

    <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
      <mat-label style="font-weight: bold;" class="get-label">Youtube Video Id</mat-label>
      <input style="width: 500px;" type="text" class="get-Input" matInput placeholder="Youtube Vieo ID" [(ngModel)]="YoutubeVideoId">
    </div>

  </div>


</div>
<div mat-dialog-actions class="dialogControllBtn">
  <a class="button button--primary" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
    <button style="margin-left: 20px;" class="button button--primary" (click)="onSubmitClick()" [disabled]="Name == null" cdkFocusInitial><span class="button__text">Submit</span></button>
</div>